import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarMix(axios, parametros) {       
    parametros.operacao = "buscarMix";
    let retorno = {};

    await axios.santriGET('/rest/mixOrcamento', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;  
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RBuscarMix.js